import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import AdminDashBoardTable from "./AdminDashBoardTable";
export const accountStatus = [
  {
    status: 'ALL',
    title: 'All',
    description: 'All the accounts',
  },
    {
      status: 'PENDING_VERIFICATION',
      title: 'Pending Verification',
      description: 'Account is pending verification.',
    },
    {
      status: 'ACTIVE',
      title: 'Active',
      description: 'Account is active and in good standing.',
    },
    {
      status: 'SUSPENDED',
      title: 'Suspended',
      description: 'Account is temporarily suspended.',
    },
    {
      status: 'DEACTIVATED',
      title: 'Deactivated',
      description: 'Account is deactivated.',
    },
    {
      status: 'BANNED',
      title: 'Banned',
      description: 'Account is permanently banned due to violations.',
    },
    {
      status: 'CLOSED',
      title: 'Closed',
      description: 'Account is permanently closed, pending deletion.',
    },
  ];
  
export const MainDashBoard = () => {
  // IF WANTED TO SET THE 1ST VALUE THEN REMEMBER TO SET IT IN USESTATE
  const [selectedValue, setSelectedValue] = useState("ACTIVE");
  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
  };
  return (
    <div className="space-y-7">
      <FormControl sx={{ width: "15rem" }}>
        {/* <InputLabel  id="demo-simple-select-label">Account Status</InputLabel> */}
        <Select  labelId="demo-simple-select-label" value={selectedValue} onChange={handleChange}>
          {accountStatus.map((item) => {
            return (
              <MenuItem key={item.status} value={item.status}>
                {item.title}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <AdminDashBoardTable selectedStatus={selectedValue} setSelectedStatus={setSelectedValue} />
    </div>
  );
};
